import { render, staticRenderFns } from "./planning-modality-chart.vue?vue&type=template&id=9b6164be&scoped=true&lang=pug&"
import script from "./planning-modality-chart.vue?vue&type=script&lang=ts&"
export * from "./planning-modality-chart.vue?vue&type=script&lang=ts&"
import style0 from "./planning-modality-chart.vue?vue&type=style&index=0&id=9b6164be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6164be",
  null
  
)

export default component.exports